var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElection1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_1636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0441 5.70441H5.95588C2.66667 5.70441 0 8.37009 0 11.6593V41.773C0 45.0622 2.66667 47.7279 5.95588 47.7279H44.0441C47.3333 47.7279 50 45.0622 50 41.773V11.6593C50 8.37009 47.3333 5.70441 44.0441 5.70441ZM8.39902 13.677C6.75588 13.677 5.42451 12.3456 5.42451 10.7034C5.42451 9.06029 6.75588 7.72892 8.39902 7.72892C10.0412 7.72892 11.3725 9.06029 11.3725 10.7034C11.3725 12.3456 10.0412 13.677 8.39902 13.677ZM16.699 13.677C15.0569 13.677 13.7255 12.3456 13.7255 10.7034C13.7255 9.06029 15.0569 7.72892 16.699 7.72892C18.3422 7.72892 19.6735 9.06029 19.6735 10.7034C19.6735 12.3456 18.3422 13.677 16.699 13.677ZM25 13.677C23.3578 13.677 22.0265 12.3456 22.0265 10.7034C22.0265 9.06029 23.3578 7.72892 25 7.72892C26.6422 7.72892 27.9735 9.06029 27.9735 10.7034C27.9735 12.3456 26.6422 13.677 25 13.677ZM33.301 13.677C31.6578 13.677 30.3265 12.3456 30.3265 10.7034C30.3265 9.06029 31.6578 7.72892 33.301 7.72892C34.9431 7.72892 36.2745 9.06029 36.2745 10.7034C36.2745 12.3456 34.9431 13.677 33.301 13.677ZM41.601 13.677C39.9588 13.677 38.6275 12.3456 38.6275 10.7034C38.6275 9.06029 39.9588 7.72892 41.601 7.72892C43.2441 7.72892 44.5755 9.06029 44.5755 10.7034C44.5755 12.3456 43.2441 13.677 41.601 13.677Z",
    fill: "url(#paint0_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0442 5.70441H22.2961V9.46519C22.7648 8.44068 23.8001 7.72892 25.0001 7.72892C26.6422 7.72892 27.9736 9.06029 27.9736 10.7034C27.9736 12.3456 26.6422 13.677 25.0001 13.677C23.7991 13.677 22.7648 12.9652 22.2961 11.9407V47.7279H44.0442C47.3334 47.7279 50.0001 45.0622 50.0001 41.773V11.6593C50.0001 8.37009 47.3334 5.70441 44.0442 5.70441ZM33.301 13.677C31.6579 13.677 30.3265 12.3456 30.3265 10.7034C30.3265 9.06029 31.6579 7.72892 33.301 7.72892C34.9432 7.72892 36.2746 9.06029 36.2746 10.7034C36.2746 12.3456 34.9432 13.677 33.301 13.677ZM41.601 13.677C39.9589 13.677 38.6275 12.3456 38.6275 10.7034C38.6275 9.06029 39.9589 7.72892 41.601 7.72892C43.2442 7.72892 44.5756 9.06029 44.5756 10.7034C44.5756 12.3456 43.2442 13.677 41.601 13.677Z",
    fill: "url(#paint1_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39893 7.72892C10.0411 7.72892 11.3725 9.06029 11.3725 10.7034C11.3725 12.3456 10.0411 13.677 8.39893 13.677H16.6989C15.0568 13.677 13.7254 12.3456 13.7254 10.7034C13.7254 9.06029 15.0568 7.72892 16.6989 7.72892V5.70441H8.39893V7.72892Z",
    fill: "url(#paint2_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.699 7.72892C18.3411 7.72892 19.6725 9.06029 19.6725 10.7034C19.6725 12.3456 18.3411 13.677 16.699 13.677H24.999C23.3568 13.677 22.0254 12.3456 22.0254 10.7034C22.0254 9.06029 23.3568 7.72892 24.999 7.72892V5.70441H16.699V7.72892Z",
    fill: "url(#paint3_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.999 7.72892C26.6412 7.72892 27.9726 9.06029 27.9726 10.7034C27.9726 12.3456 26.6412 13.677 24.999 13.677H33.299C31.6569 13.677 30.3255 12.3456 30.3255 10.7034C30.3255 9.06029 31.6569 7.72892 33.299 7.72892V5.70441H24.999V7.72892Z",
    fill: "url(#paint4_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2991 7.72892C34.9412 7.72892 36.2726 9.06029 36.2726 10.7034C36.2726 12.3456 34.9412 13.677 33.2991 13.677H41.5991C39.9569 13.677 38.6255 12.3456 38.6255 10.7034C38.6255 9.06029 39.9569 7.72892 41.5991 7.72892V5.70441H33.2991V7.72892Z",
    fill: "url(#paint5_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6 7.72892H41.601C43.2441 7.72892 44.5755 9.06029 44.5755 10.7034C44.5755 12.3456 43.2441 13.677 41.601 13.677H49.8991C48.257 13.677 46.9256 12.3456 46.9256 10.7034C46.9256 9.4797 47.6643 8.42931 48.7196 7.97264C47.6288 6.59166 45.9406 5.70441 44.0441 5.70441H41.5991V7.72892H41.6Z",
    fill: "url(#paint6_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5991 13.677H41.601L41.6 13.6769L41.5991 13.677Z",
    fill: "url(#paint7_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9878V41.7727C0 45.0619 2.66637 47.7282 5.95549 47.7282H44.0445C47.3336 47.7282 50 45.0619 50 41.7727V23.9878H0Z",
    fill: "url(#paint8_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3988 11.3382C7.50547 11.3382 6.78125 10.614 6.78125 9.72069V3.88922C6.78125 2.99588 7.50547 2.27167 8.3988 2.27167C9.29213 2.27167 10.0163 2.99588 10.0163 3.88922V9.72069C10.0163 10.614 9.29213 11.3382 8.3988 11.3382Z",
    fill: "url(#paint9_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6993 11.3382C15.806 11.3382 15.0818 10.614 15.0818 9.72069V3.88922C15.0818 2.99588 15.806 2.27167 16.6993 2.27167C17.5927 2.27167 18.3169 2.99588 18.3169 3.88922V9.72069C18.317 10.614 17.5928 11.3382 16.6993 11.3382Z",
    fill: "url(#paint10_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 11.3382C24.1068 11.3382 23.3826 10.614 23.3826 9.72069V3.88922C23.3826 2.99588 24.1068 2.27167 25.0001 2.27167C25.8935 2.27167 26.6177 2.99588 26.6177 3.88922V9.72069C26.6177 10.614 25.8935 11.3382 25.0001 11.3382Z",
    fill: "url(#paint11_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3007 11.3382C32.4073 11.3382 31.6831 10.614 31.6831 9.72069V3.88922C31.6831 2.99588 32.4073 2.27167 33.3007 2.27167C34.194 2.27167 34.9182 2.99588 34.9182 3.88922V9.72069C34.9182 10.614 34.194 11.3382 33.3007 11.3382Z",
    fill: "url(#paint12_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6014 11.3382C40.7081 11.3382 39.9839 10.614 39.9839 9.72069V3.88922C39.9839 2.99588 40.7081 2.27167 41.6014 2.27167C42.4948 2.27167 43.219 2.99588 43.219 3.88922V9.72069C43.219 10.614 42.4949 11.3382 41.6014 11.3382Z",
    fill: "url(#paint13_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5448 23.037H7.57442C6.59981 23.037 5.80981 22.247 5.80981 21.2724V17.302C5.80981 16.3274 6.59981 15.5374 7.57442 15.5374H11.5448C12.5194 15.5374 13.3094 16.3274 13.3094 17.302V21.2724C13.3094 22.247 12.5193 23.037 11.5448 23.037Z",
    fill: "url(#paint14_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8385 23.037H17.8681C16.8935 23.037 16.1035 22.247 16.1035 21.2724V17.302C16.1035 16.3274 16.8935 15.5374 17.8681 15.5374H21.8385C22.8131 15.5374 23.6031 16.3274 23.6031 17.302V21.2724C23.6031 22.247 22.813 23.037 21.8385 23.037Z",
    fill: "url(#paint15_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.132 23.037H28.1616C27.187 23.037 26.397 22.247 26.397 21.2724V17.302C26.397 16.3274 27.187 15.5374 28.1616 15.5374H32.132C33.1066 15.5374 33.8966 16.3274 33.8966 17.302V21.2724C33.8966 22.247 33.1066 23.037 32.132 23.037Z",
    fill: "url(#paint16_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4257 23.037H38.4553C37.4807 23.037 36.6907 22.247 36.6907 21.2724V17.302C36.6907 16.3274 37.4807 15.5374 38.4553 15.5374H42.4257C43.4003 15.5374 44.1903 16.3274 44.1903 17.302V21.2724C44.1903 22.247 43.4003 23.037 42.4257 23.037Z",
    fill: "url(#paint17_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5448 33.6247H7.57442C6.59981 33.6247 5.80981 32.8347 5.80981 31.8601V27.8897C5.80981 26.9151 6.59981 26.1251 7.57442 26.1251H11.5448C12.5194 26.1251 13.3094 26.9151 13.3094 27.8897V31.8601C13.3094 32.8346 12.5193 33.6247 11.5448 33.6247Z",
    fill: "url(#paint18_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8385 33.6247H17.8681C16.8935 33.6247 16.1035 32.8347 16.1035 31.8601V27.8897C16.1035 26.9151 16.8935 26.1251 17.8681 26.1251H21.8385C22.8131 26.1251 23.6031 26.9151 23.6031 27.8897V31.8601C23.6031 32.8346 22.813 33.6247 21.8385 33.6247Z",
    fill: "url(#paint19_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.132 33.6247H28.1616C27.187 33.6247 26.397 32.8347 26.397 31.8601V27.8897C26.397 26.9151 27.187 26.1251 28.1616 26.1251H32.132C33.1066 26.1251 33.8966 26.9151 33.8966 27.8897V31.8601C33.8966 32.8346 33.1066 33.6247 32.132 33.6247Z",
    fill: "url(#paint20_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4257 33.6247H38.4553C37.4807 33.6247 36.6907 32.8347 36.6907 31.8601V27.8897C36.6907 26.9151 37.4807 26.1251 38.4553 26.1251H42.4257C43.4003 26.1251 44.1903 26.9151 44.1903 27.8897V31.8601C44.1903 32.8346 43.4003 33.6247 42.4257 33.6247Z",
    fill: "url(#paint21_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5448 44.2123H7.57442C6.59981 44.2123 5.80981 43.4223 5.80981 42.4477V38.4773C5.80981 37.5027 6.59981 36.7127 7.57442 36.7127H11.5448C12.5194 36.7127 13.3094 37.5027 13.3094 38.4773V42.4477C13.3094 43.4223 12.5193 44.2123 11.5448 44.2123Z",
    fill: "url(#paint22_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8385 44.2123H17.8681C16.8935 44.2123 16.1035 43.4223 16.1035 42.4477V38.4773C16.1035 37.5027 16.8935 36.7127 17.8681 36.7127H21.8385C22.8131 36.7127 23.6031 37.5027 23.6031 38.4773V42.4477C23.6031 43.4223 22.813 44.2123 21.8385 44.2123Z",
    fill: "url(#paint23_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7423 32.7358L21.1556 40.3227L18.1204 41.1682L24.68 47.728H43.7345L28.7423 32.7358Z",
    fill: "url(#paint24_linear_154_1636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0817 41.9794C19.3714 41.9794 18.6611 41.709 18.1204 41.1683L15.6858 38.7337C15.2073 38.2551 15.2073 37.4792 15.6858 37.0006C16.1644 36.522 16.9403 36.522 17.4189 37.0006L19.8535 39.4352C19.9317 39.5133 20.0208 39.5297 20.0818 39.5297C20.1428 39.5297 20.2319 39.5133 20.31 39.4352L27.0093 32.7359C27.488 32.2573 28.2638 32.2573 28.7425 32.7359C29.221 33.2145 29.221 33.9904 28.7425 34.469L22.0432 41.1683C21.5023 41.709 20.7921 41.9794 20.0817 41.9794Z",
    fill: "url(#paint25_linear_154_1636)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_1636",
    x1: 20.9823,
    y1: 15.3528,
    x2: 36.5282,
    y2: 59.3212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8D3D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_1636",
    x1: 44.3063,
    y1: 26.7162,
    x2: 52.1433,
    y2: 26.7162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_154_1636",
    x1: 11.2606,
    y1: 8.70745,
    x2: 8.77696,
    y2: 6.81205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_154_1636",
    x1: 19.5606,
    y1: 8.70745,
    x2: 17.077,
    y2: 6.81205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_154_1636",
    x1: 27.8607,
    y1: 8.70745,
    x2: 25.3771,
    y2: 6.81205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_154_1636",
    x1: 36.1607,
    y1: 8.70745,
    x2: 33.6771,
    y2: 6.81205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_154_1636",
    x1: 43.7538,
    y1: 9.63372,
    x2: 41.2702,
    y2: 7.73833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_154_1636",
    x1: 41.5999,
    y1: 13.6768,
    x2: 41.5995,
    y2: 13.6766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_154_1636",
    x1: 25,
    y1: 40.3286,
    x2: 25,
    y2: 50.1665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_154_1636",
    x1: 7.36939,
    y1: 6.805,
    x2: 9.6189,
    y2: 6.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_154_1636",
    x1: 15.67,
    y1: 6.805,
    x2: 17.9194,
    y2: 6.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_154_1636",
    x1: 23.9708,
    y1: 6.805,
    x2: 26.2202,
    y2: 6.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_154_1636",
    x1: 32.2712,
    y1: 6.805,
    x2: 34.5208,
    y2: 6.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_154_1636",
    x1: 40.5721,
    y1: 6.805,
    x2: 42.8215,
    y2: 6.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_154_1636",
    x1: -3.52803,
    y1: 6.19961,
    x2: 19.0568,
    y2: 28.7843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_154_1636",
    x1: 6.76567,
    y1: 6.19961,
    x2: 29.3505,
    y2: 28.7843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_154_1636",
    x1: 17.0592,
    y1: 6.19961,
    x2: 39.6439,
    y2: 28.7843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_154_1636",
    x1: 27.3529,
    y1: 6.19961,
    x2: 49.9376,
    y2: 28.7843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_154_1636",
    x1: -3.52803,
    y1: 16.7874,
    x2: 19.0568,
    y2: 39.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_154_1636",
    x1: 6.76567,
    y1: 16.7874,
    x2: 29.3505,
    y2: 39.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_154_1636",
    x1: 17.0592,
    y1: 16.7874,
    x2: 39.6439,
    y2: 39.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_154_1636",
    x1: 27.3529,
    y1: 16.7874,
    x2: 49.9376,
    y2: 39.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_154_1636",
    x1: -3.52803,
    y1: 27.375,
    x2: 19.0568,
    y2: 49.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA1B1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_154_1636",
    x1: 6.76567,
    y1: 27.375,
    x2: 29.3505,
    y2: 49.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C0FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_154_1636",
    x1: 32.9894,
    y1: 46.5101,
    x2: 19.5279,
    y2: 33.0485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017BAE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_154_1636",
    x1: 19.7756,
    y1: 33.2963,
    x2: 25.9527,
    y2: 39.4733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC727"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_1636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElection1);
export default __webpack_public_path__ + "static/media/election 1.e971a76fea3f9dcaec22871815b908da.svg";
export { ForwardRef as ReactComponent };